import { atom } from "recoil";

export const activeResendCodeState = atom({
    key: 'activeResendCode',
    default: false
})